<template>
  <div class="dashboard-main-content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12">
          <div class="form-box">
            <div class="form-title-wrap">
              <div class="d-flex align-items-center justify-content-between">
                <h3 class="title">Acente</h3>
              </div>
            </div>
            <v-app>
              <div class="card-item p-3">
                <div class="contact-form-action">
                  <div class="input-box">
                    <label class="label-text">Sefer :</label>
                    <v-autocomplete :items="sailList"
                                    :onchange="onSailSelected"
                                    v-model="selectedSail"
                                    flat hide-no-data
                                    :menu-props='{ nudgeTop: 110,maxHeight: 175}'
                                    hide-details
                                    item-value="id"
                                    placeholder="Sefer">
                      <template slot="selection" slot-scope="{ item, selected }">
                        {{item.sailDate | ddMMyyyy}}
                      </template>
                      <template slot="item" slot-scope="{ item, tile }">
                        <v-list-tile-content>
                          {{item.sailDate | ddMMyyyy}}
                        </v-list-tile-content>
                      </template>
                    </v-autocomplete>

                  </div>
                </div>
              </div>
              <div class="form-content pb-2" v-for="agency in agencyList" v-if="agencyProformas && selectedSail && agencyList">
                <div class="form-title-wrap">
                  <div class="d-flex align-items-center justify-content-between">
                    <h3 class="title">{{ agency.name }}</h3>
                    <button @click="createNewProforma(agency.id)" class="theme-btn" type="button">Yeni Proforma Fatura Üret</button>
                  </div>
                  <div>
                    <div class="row" style="padding-bottom: 1px">
<!--                      <p class="booking-count"> <b>Rezervasyon</b> : {{ agency.bookingCount }}</p>   <p class="booking-count"> <b>Oda</b> : {{ agency.roomCount }}</p>   <p class="booking-count"> <b>Yolcu</b> : {{ agency.passengerCount }}</p>-->
                      <p class="booking-count"> <b>Rezervasyon</b> : {{ agency.bookingCount }}</p>   <p class="booking-count"> <b>Oda</b> : ?</p>   <p class="booking-count"> <b>Yolcu</b> : ?</p>
                    </div>
                  </div>
                </div>
                <v-data-table
                    :headers="headers"
                    :items="filterProformasByAgencyIdAndSailId(agency.id, selectedSail)"
                    :items-per-page="5"
                    class="elevation-1">
                  <template v-slot:item.id="{ item }">
                    <th><a :href="basePath+'/proforma-detail/'+item.id">#{{item.id}}</a></th>
                  </template>
                  <template v-slot:item.createDate="{ item }">
                    <tr>
                      {{ item.createDate | ddMMyyyyHHmmSS }}
                    </tr>
                  </template>
                  <template v-slot:item.sailId="{ item }">
                    <tr>
                      {{ sailsLiteMap[item.sailId].sailDate | ddMMyyyy }}
                    </tr>
                  </template>
                  <template v-slot:item.agencyId="{ item }">
                    <tr>
                      {{ agencyMap[item.agencyId].name }}
                    </tr>
                  </template>
                  <template v-slot:item.edit="{ item }">
                    <div class="table-content">
                      <a style="color: white" href="javascript:void(0)"
                         class="theme-btn theme-btn-small" data-toggle="tooltip" data-placement="top" title=""
                         data-original-title="Edit"
                      @click="downloadProforma(item.documentStoreId)">
                        <i class="la la-download"></i></a>
                    </div>
                  </template>
                </v-data-table>
              </div>
            </v-app>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import messagePopupManager from "../../util/messagePopupManager";

export default {
  name: "AgencyProformaList",
  data () {
    return {
      loading: false,
      selectedSail: null,
      headers: [
        {
          text: '#ID',
          align: 'start',
          sortable: true,
          value: 'id',
        },
        {
          text: 'Acente',
          sortable: true,
          value: 'agencyId',
        },
        {
          text: 'Sefer',
          sortable: true,
          value: 'sailId',
        },
        {
          text: 'Fatura Numarası',
          sortable: true,
          value: 'invoiceId',
        },
        {
          text: 'Üretim Tarihi',
          value: 'createDate',
        },
        {
          text: 'Edit',
          value: 'edit',
        }
      ]
    }
  },
  computed:{
    sailList:{
      get(){
        return this.$store.getters.getSailsLite;
      }
    },
    sailsLiteMap:{
      get(){
        return this.$store.getters.getSailsLiteMap;
      }
    },
    agencyMap:{
      get(){
        return this.$store.getters.getAgencyListMap;
      }
    },
    agencyList:{
      get(){
        return this.$store.getters.getAgenciesBySailList;
      }
    },
    agencyProformas:{
      get(){
        return this.$store.getters.getAgencyProformas;
      }
    }
  },
  methods:{
    onSailSelected: function (){
      this.$store.dispatch("loadAgencyBySailList", this.selectedSail);
    },
    filterProformasByAgencyIdAndSailId : function (agencyId) {
      if(this.agencyProformas !== null){
        return this.agencyProformas.filter((agencyProforma)=>{
          return agencyProforma.agencyId === agencyId && agencyProforma.sailId === this.selectedSail;
        });
      }else{
        return [];
      }
    },
    downloadProforma : function (id){
      this.$store.dispatch("downloadProforma", {id: id});
    },
    createNewProforma : function (agencyId){
      if(this.loading === true) return;
      this.loading = true;
      this.$store.dispatch("generateProforma", {agencyId: agencyId, sailId: this.selectedSail }).then(()=>{
        this.$store.dispatch("loadAgencyProformas");
      }).catch(error => {
        messagePopupManager.showError("Hata", error.response.data.message);
      }).finally(() => {
        this.loading = false;
      });
    }
  },
  watch: {
    selectedSail: {
      handler: function () {
        this.onSailSelected();
      }
    }
  }
}
</script>

<style scoped>
.booking-count {
  margin-left: 15px !important;
  font-weight: normal !important;
  font-size: 14px !important;
}
</style>